// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Titel */
.section-title.kinder {
  color: var(--dunkelgruen) !important;
}

/* Button-Stil für Kinder-Bereich */
.button_boring_red.kinder {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;
  margin: 2px;
  background-color: var(--dunkelgruen) !important;
  color: white;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.4rem;
  font-weight: normal;
  text-transform: uppercase;
  padding: 1rem 1rem;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-align: left;
  line-height: 1.2;
  min-height: 120px;
}

.button_boring_red.kinder:hover {
  background-color: #5a7502 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease, transform 0.2s ease;
}

/* Icon-Stil */
.button_boring_red.kinder .material-icons {
  font-size: 2rem;
  margin-top: 0.2rem;
}

.button_boring_red.kinder .material-symbols-outlined {
  color: white;
  font-size: 2rem;
}

@media (max-width: 768px) {
  .button-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .section-title.kinder {
    font-size: 2.5rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/kinder/Kinder.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,oCAAoC;AACtC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,+CAA+C;EAC/C,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;EACzC,2DAA2D;AAC7D;;AAEA,cAAc;AACd;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* Titel */\n.section-title.kinder {\n  color: var(--dunkelgruen) !important;\n}\n\n/* Button-Stil für Kinder-Bereich */\n.button_boring_red.kinder {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin: 2px;\n  background-color: var(--dunkelgruen) !important;\n  color: white;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.4rem;\n  font-weight: normal;\n  text-transform: uppercase;\n  padding: 1rem 1rem;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  text-align: left;\n  line-height: 1.2;\n  min-height: 120px;\n}\n\n.button_boring_red.kinder:hover {\n  background-color: #5a7502 !important;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n/* Icon-Stil */\n.button_boring_red.kinder .material-icons {\n  font-size: 2rem;\n  margin-top: 0.2rem;\n}\n\n.button_boring_red.kinder .material-symbols-outlined {\n  color: white;\n  font-size: 2rem;\n}\n\n@media (max-width: 768px) {\n  .button-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .section-title.kinder {\n    font-size: 2.5rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
